import { render } from "./PWAInstallPrompt.vue?vue&type=template&id=6e0b67e2"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"

import "./PWAInstallPrompt.vue?vue&type=style&index=0&id=6e0b67e2&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.2.13_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__